import { useOrganization } from "@/queries/organization-queries";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";

/**
 * Hook that returns true if hosted compute UI should be enabled.
 * Returns true if the organization tier is FREE_ONA or CORE.
 */
export const useHostedComputeUI = () => {
    const { data: organization, isLoading: orgLoading } = useOrganization();

    const tierEnabled =
        organization?.tier === OrganizationTier.FREE_ONA || organization?.tier === OrganizationTier.CORE;

    return {
        value: tierEnabled,
        loading: orgLoading,
    };
};
